class ModalComponent extends HTMLElement {
  constructor() {
    super();
    this.modalContent = this.querySelector("[data-modal-content]");
    this.closeButtons = [...this.querySelectorAll("[data-modal-close]")];
    this.waitlistContent = this.querySelector('#collection-waitlist');
    this.initFunction();
  }

  initFunction() {
    const modalId = this.dataset.id;
    document.addEventListener("click", (event) => {
      if (event.target.nodeName === 'BUTTON' && event.target.getAttribute('data-modal-trigger') == modalId) {
        event.stopPropagation();
        this.openModal();
      }
    }, false)

    document.addEventListener("click", (event) => {
      if (event.target.nodeName === 'MODAL-COMPONENT') {
        event.stopPropagation();
        this.closeModal();
      }
    }, false)

    this.closeButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.stopPropagation();
        this.closeModal();
      });
    })
  }

  closeModal() {
    document.documentElement.classList.remove("overflow-hidden");
    document.body.classList.remove("overflow-hidden");
    this.classList.remove("show-modal");
  }

  openModal() {
    this.classList.remove("success", "error");
    document.documentElement.classList.add("overflow-hidden");
    document.body.classList.add("overflow-hidden");
    this.classList.add("show-modal");
    this.waitlistContent && this.waitlistContent.classList.remove('success');
  }

  toggleModal() {
    if (!this.classList.contains('show-modal')) {
      this.openModal();
    } else {
      this.closeModal();
    }
  }
}

if (!customElements.get("modal-component")) {
  customElements.define("modal-component", ModalComponent);
}
